import { useQuery } from "@tanstack/react-query";
import type { UseQueryResult } from "@tanstack/react-query";
import { getMeetingOverallScores } from "../api/meeting-api";
import type { OverallScores } from "../types/meeting.type";

const STALE_TIME = 30_000;

export const overallScoresKeys = {
  overall: (rfxId: number, evalId: number) =>
    ["meetingOverallScores", rfxId, evalId] as const,
};

interface UseOverallScoresResult {
  data: OverallScores | undefined;
  isLoading: boolean;
  isError: boolean;
  refetch: () => void;
}

export const useOverallScores = (
  rfxId: number | undefined,
  evalId: number | undefined
): UseOverallScoresResult => {
  const query: UseQueryResult<OverallScores> = useQuery({
    queryKey: overallScoresKeys.overall(rfxId!, evalId!),
    queryFn: () => getMeetingOverallScores(rfxId!, evalId!),
    enabled: !!rfxId && !!evalId,
    staleTime: STALE_TIME,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  };
};
